<template>
  <div>
    <PageTitle v-bind:title="'Base Indiv'" />

    <b-container fluid="xxl" class="mt-2">
      <b-row class="mt-4">
        <b-col>
          <b-button
            v-if="config.editable"
            variant="primary"
            size="sm"
            :disabled="!$store.getters.checkRole('legam.scripta.baseindiv.add')"
            class="float-right mb-4"
            v-b-modal.modal-new-baseindiv
          >
            <b-icon icon="plus-circle-fill" aria-hidden="true"></b-icon>
            Add new base indiv
          </b-button>
          <b-modal
            v-if="config.editable"
            id="modal-new-baseindiv"
            title="New base indiv"
            ok-title="Save"
            @ok="saveBaseindiv"
            size="lg"
          >
            <BaseIndivNewEdit />
          </b-modal>
          <LegamDataTables v-if="config.editable" v-bind="$data" />
          <LegamDataTablesClientSide v-else v-bind="$data" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
* >>> .tdAction {
  width: 150px;
}
</style>

<script>
// import { mapState } from 'vuex'
import router from "@/router";
import PageTitle from "@/components/PageTitle.vue";
import LegamDataTables from "@/components/LegamDataTables.vue";
import LegamDataTablesClientSide from "@/components/LegamDataTablesClientSide.vue";
import tdColAction from "@/components/tdColAction";
import BaseIndivNewEdit from "@/components/Scripta/BaseIndivNewEdit";
import HelpStore from "@/store/helpstore.js";
import config from '@/config.js'

export default {
  name: "BaseIndivs",
  data() {
    return {
      columns: [
        {
          title: "Form",
          field: "form",
          sortable: true,
          searchable: true,
        },
        {
          title: "Comment",
          field: "comment",
          sortable: true,
          searchable: true,
        },
        {
          title: "Heads",
          field: "heads",
          tdComp: tdColAction,
          sortable: true,
          searchable: true,
          transformData: function (row) {
            return row.heads.map(head => {
              return {
                text: head.form,
                icon: null,
                id: head.id,
                to: {
                  name: "HeadDetails",
                  params: {
                    id: head.id,
                  },
                },
              }
            })
          }
        },
        {
          title: "Action",
          field: "action",
          tdComp: tdColAction,
          thClass: "tdAction",
          transformData: function (row) {
            return [
              {
                text: null,
                icon: "list-ul",
                id: row.id,
                to: {
                  name: "BaseIndivDetails",
                  params: {
                    id: row.id,
                  },
                },
              },
            ];
          },
        },
      ],
      url: "/baseindivs/datatables",
      searchableByColumn: true,
      config: config,
    };
  },
  components: {
    PageTitle,
    LegamDataTables,
    LegamDataTablesClientSide,
    BaseIndivNewEdit,
  },
  methods: {
    saveBaseindiv() {
      this.$store.dispatch("createBaseindiv", HelpStore.item).then((response) => {
        router.push(`/baseindiv/${response.data.id}`);
      });
    },
  },
};
</script>
